import { FileContentType } from '../../libs/enums';
import { mustBeContentType, mustBeFeatherThan, mustBeFilled } from '../../libs/validators';

const INPUT_NAME = 'fileUpload';

const ALLOWED_KEYS = Object.keys(FileContentType).join(',');
const ALLOWED_VALUES = Object.values(FileContentType).join(', ');

export const inputFileUploadConfig = {
  accept: ALLOWED_VALUES,
  name: INPUT_NAME,
  validators: {
    format: [
      mustBeFeatherThan(
        2,
        INPUT_NAME,
        'La taille du document excède la taille maximale autorisée.',
      ),
      mustBeContentType(
        ALLOWED_VALUES,
        INPUT_NAME,
        `Le format du fichier n’est pas valide, seuls les formats suivants sont acceptés : ${ALLOWED_KEYS}).`,
      ),
    ],
    submit: mustBeFilled('Veuillez sélectionner un fichier'),
  },
};
